import {
  ContactInfoActions,
  ContactInfoActionTypes
} from '@staff-app/actions/contact-info.actions';
import {ContactInfoDTO} from '@staff-app/models/termStaffContactInfoDTO';
import {CommonActions, CommonActionTypes} from '@store/actions/common.actions';

export interface State {
  contactInfo: ContactInfoDTO;
}

export const initialState: State = {
  contactInfo: null
};

export function reducer(
  state = initialState,
  action: ContactInfoActions | CommonActions
): State {
  switch (action.type) {
    case ContactInfoActionTypes.GetContactInfoSuccessful: {
      return {
        ...state,
        contactInfo: action.payload
      };
    }
    case ContactInfoActionTypes.SaveContactInfoSuccessful:
    case ContactInfoActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage: {
      return initialState;
      // remove store to prevent data load from cache
    }
    default: {
      return state;
    }
  }
}

export const getContactInfo = (state: State) => state.contactInfo;
